function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*
  ------------------------------------------------------------------------------
  Accepts String, Element, NodeList, Array and returns Array of elements

  @param {String|Array|Element|NodeList} elements
  @returns {Array}
*/
var getElements = function getElements(elements) {
  var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

  if (typeof elements === "string") {
    return _toConsumableArray(source.querySelectorAll(elements));
  }

  if (isNodeList(elements)) {
    return _toConsumableArray(elements);
  }

  if (Array.isArray(elements)) {
    return elements;
  } // Element


  return [elements];
};
/*
  ------------------------------------------------------------------------------
  Based on how Element.closest() works. Returns true if `element` has the
  closest ancestor (or is itself) that matches the `matches` (element|selector)

  @param {String|Element} element
  @param {String|Element} matches
  @returns {Bool}
*/


var hasClosest = function hasClosest(element, matches) {
  element = getElements(element)[0];

  if (typeof matches === "string") {
    return element.closest(matches) ? true : false;
  } else {
    while (element) {
      if (element === matches) {
        return true;
      }

      element = element.parentNode;
    }

    return false;
  }
};
/*
  ------------------------------------------------------------------------------
  Returns an Array of parents of `element` that matches the given `selector`
  up until the `until` matching element|selector

  @param {String|Element} element
  @param {String} selector [optional]
  @param {String|Element} until [optional]
  @returns {Array}
*/


var getParents = function getParents(element) {
  var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var until = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  element = getElements(element)[0];
  element = element.parentNode;
  var parents = [];

  while (element) {
    if (element === document) {
      break;
    }

    if (!selector || element.matches(selector)) {
      parents.push(element);
    }

    if (until) {
      if (typeof until === "string") {
        if (element.matches(until)) {
          break;
        }
      } else if (element === until) {
        break;
      }
    }

    element = element.parentNode;
  }

  return parents;
};
/*
  ------------------------------------------------------------------------------
  Checks if provided `nodes` is a type of NodeList

  @param {Any} nodes
  @returns {Bool}
*/


var isNodeList = function isNodeList(nodes) {
  var stringRepr = Object.prototype.toString.call(nodes);
  return typeof nodes === "object" && /^\[object (HTMLCollection|NodeList|Object)\]$/.test(stringRepr) && typeof nodes.length === "number" && (nodes.length === 0 || typeof nodes[0] === "object" && nodes[0].nodeType > 0);
};
/*
  ------------------------------------------------------------------------------
*/


export { getElements, hasClosest, getParents, isNodeList };